<template>
  <div class="embed-dashboards">
    <portal to="layout-nav-title">{{ $t('menu.embedDashboard') }}</portal>

    <iframe
      v-if="src"
      :src="src"
      frameborder="0"
      class="embed-dashboards__frame"
    />

    <div v-else class="embed-dashboards__placeholder">
      {{ $t(loadFailed ? 'hint.embedDashboardLoadFailed' : 'hint.embedDashboardUrlPending') }}
    </div>  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

// 客户提供的看板票据入口（客户校验票据建立会话后重定向到看板），客户提供后替换
const DASHBOARD_URL = 'https://order-monitor.inflation.com.cn/sso/exchange';

@Component
export default class EmbedDashboards extends Vue {
  src = '';
  loadFailed = false;

  async created() {
    if (!DASHBOARD_URL) return;

    try {
      const { ticket } = await this.$request.post('/embed_tickets');
      this.src = `${DASHBOARD_URL}${DASHBOARD_URL.includes('?') ? '&' : '?'}ticket=${encodeURIComponent(ticket)}`;
    } catch (e) {
      this.loadFailed = true;
    }
  }
}

export const route = [
  {
    path: '/embed_dashboards',
    name: 'embed_dashboards',
    component: EmbedDashboards,
    meta: {
      can: ['embed_dashboards.read']
    }
  }
];
</script>

<style lang="scss" scoped>
.embed-dashboards {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 110px);
  padding: 20px;

  &__frame {
    flex: 1;
    display: block;
    width: 100%;
    border: 0;
    background: #fff;
  }

  &__placeholder {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    color: #909399;
  }
}
</style>
